import _ from 'lodash';

import {objectsEqual} from './objectHelper';

export const getIndexSliceStartEnd = (currIndex, minIndex, maxIndex) => {
  let result = {
    start: 0,
    end: 0,
  };

  if (currIndex < minIndex && maxIndex === minIndex) {
    result = {
      start: currIndex,
      end: minIndex + 1,
    };
  } else if (currIndex > maxIndex && maxIndex === minIndex) {
    result = {
      start: maxIndex,
      end: currIndex + 1,
    };
  } else if (currIndex < Math.min(minIndex, maxIndex)) {
    result = {
      start: currIndex,
      end: maxIndex + 1,
    };
  } else if (currIndex > Math.max(minIndex, maxIndex)) {
    result = {
      start: minIndex,
      end: currIndex + 1,
    };
  } else if (currIndex > minIndex && currIndex < maxIndex) {
    result = {
      start: currIndex,
      end: maxIndex + 1,
    };
  } else {
    result = {
      start: currIndex,
      end: currIndex + 1,
    };
  }

  return result;
};

export function rotateClockwise(array) {
  const result = [];
  array.forEach((a, i, aa) => {
    a.forEach((b, j) => {
      result[j] = result[j] || [];
      result[j][aa.length - i - 1] = b;
    });
  });
  return result;
}

export function rotateCounterClockwise(array) {
  const result = [];
  array.forEach((a, i) => {
    a.forEach((b, j, bb) => {
      result[bb.length - j - 1] = result[bb.length - j - 1] || [];
      result[bb.length - j - 1][i] = b;
    });
  });
  return result;
}

export const generateArrLetters = (length, capital = false) =>
  [...Array(length)].map((_, i) => String.fromCharCode(i + (capital ? 65 : 97)));

export const generateArrNumbers = (length, startNumber = 1) => Array.from({length}, (_, i) => i + startNumber);

export const arraysEqual = (a1, a2) => a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));

export const generateNextID = (state = [], stateKey = 'ID') => {
  const maxCard = _.maxBy(state, stateKey);
  return maxCard ? maxCard.ID + 1 : 1;
};

/// [...a],[...b]
export const mergeArrayObj = (a, b, prop) => {
  const reduced = a.filter((aitem) => !b.find((bitem) => aitem[prop] === bitem[prop]));
  return reduced.concat(b);
};
/// [[],[]]
export const mergeMultipleArrayObj = (datas = [], prop = null) =>
  datas.reduce((a = [], b = []) => [...mergeArrayObj([...a], [...b], prop)], []);

export const isArrayOfObject = (array) =>
  Array.isArray(array) && array.some((item) => item && typeof value === 'object' && !Array.isArray(item));

export const is2dArray = (array) => Array.isArray(array) && array.some((item) => Array.isArray(item));

export const sortByKeyWithRegex = (array, key = 'FileName', regex = /50\s?mL/i) =>
  [...array].sort((a, b) => {
    const nameA = a[key].match(regex);
    const nameB = b[key].match(regex);

    if (nameA && nameB) {
      return nameA[0].localeCompare(nameB[0]);
    }
    if (nameA) {
      return -1;
    }
    if (nameB) {
      return 1;
    }
    return 0;
  });
